import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const TrailerAccessories = ({ roles }) => {

    return (
        <M_Table entityName={'TrailerAccessory'} filtersOnTable rolePermissions={roles} />
    )
}